import Lisa from '../../pages/lisa/Lisa'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.LISA, component: Lisa }])
